import { QueryParamsModel } from '../../../_base/crud/models/query-models/query-params.model';
import { forkJoin } from 'rxjs';
// Angular
import { Injectable } from '@angular/core';
// RxJS
import { mergeMap, map, tap, delay } from 'rxjs/operators';
// NGRX
import { Effect, Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
// CRUD
import { QueryResultsModel } from '../../../_base/crud';
// Services
import { TransporterService } from '../_services/transporter.service';
import { ShareddataserviceService } from '../../../../shared/shareddataservice.service';
// State
import { AppState } from '../../../../core/reducers';
// Actions
import {
    TransporterActionTypes,
    TransporterPageRequested,
    TransporterPageLoaded,
    OneTransporterDeleted,
    TransporterActionToggleLoading,
    TransporterPageToggleLoading,
    TransporterUpdated,
    TransporterCreated,
    TransporterOnServerCreated
} from '../_actions/transporter.actions';
import { of } from 'rxjs';

@Injectable()
export class TransporterEffects {
    showPageLoadingDistpatcher = new TransporterPageToggleLoading({ isLoading: true });
    showActionLoadingDistpatcher = new TransporterActionToggleLoading({ isLoading: true });
    hideActionLoadingDistpatcher = new TransporterActionToggleLoading({ isLoading: false });

    @Effect()
    loadTransporterPage$ = this.actions$.pipe(
        ofType<TransporterPageRequested>(TransporterActionTypes.TransporterPageRequested),
        mergeMap(({ payload }) => {
            this.store.dispatch(this.showPageLoadingDistpatcher);
            const requestToServer = this.transporterService.findTransporters(payload.page);
            const lastQuery = of(payload.page);
            return forkJoin(requestToServer, lastQuery);
        }),
        map(response => {
            const result: QueryResultsModel = response[0];
            const lastQuery: QueryParamsModel = response[1];

            this.sharedService.updateTransporterList(result.items);
            //console.log(result.items);
            const pageLoadedDispatch = new TransporterPageLoaded({
                transporters: result.items,
                totalCount: result.totalCount,
                page: lastQuery
            });
            return pageLoadedDispatch;
        })
    );

    @Effect()
    deleteTransporter$ = this.actions$
        .pipe(
            ofType<OneTransporterDeleted>(TransporterActionTypes.OneTransporterDeleted),
            mergeMap(({ payload }) => {
                this.store.dispatch(this.showActionLoadingDistpatcher);
                return this.transporterService.deleteTransporter(payload.TransportMId);
            }
            ),
            map(() => {
                return this.hideActionLoadingDistpatcher;
            }),
        );

    @Effect()
    updateTransporter$ = this.actions$
        .pipe(
            ofType<TransporterUpdated>(TransporterActionTypes.TransporterUpdated),
            mergeMap(({ payload }) => {
                this.store.dispatch(this.showActionLoadingDistpatcher);
                return this.transporterService.updateTransporter(payload.transporter.TransportMId, payload.transporter);
            }),
            map(() => {
                return this.hideActionLoadingDistpatcher;
            })
        );

    @Effect()
    createTransporter$ = this.actions$
        .pipe(
            ofType<TransporterOnServerCreated>(TransporterActionTypes.TransporterOnServerCreated),
            mergeMap(({ payload }) => {
                this.store.dispatch(this.showActionLoadingDistpatcher);
                return this.transporterService.createTransporter(payload.transporter).pipe(
                    tap(res => {
                        //console.log(res);
                        //const resValue = Object.keys(res).map(key => res[key]);
                        //console.log(resValue[0].value);
                        //this.store.dispatch(new TransporterCreated({ transporter: res }));
                        if (res.TransportMId == 0) {
                            this.store.dispatch(new TransporterCreated({ transporter: res }));
                        } else {
                            console.log('There is somthing wrong');
                            //this.store.dispatch(new TransporterErrorMessage({ _errorMessage: resValue[0].value }));
                        }

                    })
                );
            }),
            map(() => {
                return this.hideActionLoadingDistpatcher;
            }),
        );

    constructor(private actions$: Actions, private transporterService: TransporterService,
        private sharedService: ShareddataserviceService, private store: Store<AppState>) { }
}
